import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Collapse from '@material-ui/core/Collapse'
import Hidden from '@material-ui/core/Hidden'
import withStyles from '../styles/withStyles'
import Typography from '../Typography'

export const styles = theme => ({
  root: {
    width: '100%',
    background: theme.palette.blue[200],
    padding: `0 20px`,

    [theme.breakpoints.up('md')]: {
      height: 'auto',
      padding: `${theme.utils.spacing(6)} ${theme.utils.spacing(
        6,
      )} ${theme.utils.spacing(7)}`,
      '& > * + *:not(:last-child)': {
        marginBottom: 40,
      },
    },
  },
  expanded: {
    paddingBottom: theme.utils.spacing(7),
  },
  blockTitle: {
    position: 'relative',
    textAlign: 'center',
    cursor: 'pointer',
    '$expanded &': {
      marginBottom: `calc(${theme.utils.spacing(5)} - ${theme.utils.spacing(
        2,
      )})`,
    },
    padding: `${theme.utils.spacing(2)} 0`,
    [theme.breakpoints.up('md')]: {
      padding: 0,
      marginLeft: 20,
      cursor: 'auto',
      textAlign: 'left',
      '&::before': {
        content: '""',
        width: 10,
        height: 10,
        position: 'absolute',
        background: theme.palette.purple[500],
        left: -15,
        right: 0,
        bottom: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      },
    },
  },
  title: {
    marginTop: `calc(${theme.utils.spacing(5)} - ${theme.utils.spacing(2)})`,
    marginBottom: theme.utils.spacing(5),
    '$expanded &': {
      marginTop: 0,
    },
    [theme.breakpoints.up('md')]: {
      marginTop: theme.utils.spacing(5),
    },
  },
})

const ExecutiveSummary = props => {
  const { classes, className: classNameProp, title, summary, ...other } = props
  const [expanded, setExpanded] = useState(false)
  const onToggle = () => setExpanded(!expanded)

  const className = classnames(
    classes.root,
    {
      [classes.expanded]: expanded,
    },
    classNameProp,
  )

  return (
    <div className={className} {...other}>
      <Hidden implementation="css" smDown>
        <Typography variant="h3" className={classes.blockTitle}>
          Executive summary
        </Typography>
        <div>
          <Typography className={classes.title} variant="h5">
            {title}
          </Typography>
          <Typography variant="body2">{summary}</Typography>
        </div>
      </Hidden>
      <Hidden implementation="css" mdUp>
        <Typography
          variant="h3"
          className={classes.blockTitle}
          onClick={onToggle}
        >
          Executive summary
        </Typography>
        <Collapse in={expanded}>
          <div>
            <Typography className={classes.title} variant="h5">
              {title}
            </Typography>
            <Typography variant="body2">{summary}</Typography>
          </div>
        </Collapse>
      </Hidden>
    </div>
  )
}

ExecutiveSummary.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  summary: PropTypes.string.isRequired,
}

ExecutiveSummary.uiName = 'ExecutiveSummary'

export default withStyles(styles)(ExecutiveSummary)
